export const REDUCER_NAME = 'gameLoader';

export const GAME_POSITIONS_LOCAL_STORAGE_KEY = 'gamePositions';

const ACTION_PREFIX = '@komigen/gameLoader';
export const CLEAN_UP = `${ACTION_PREFIX}/CLEAN_UP`;
export const SET_GAME_TO_GAME_SLOT = `${ACTION_PREFIX}/SET_GAME_TO_GAME_SLOT`;
export const SET_GAME_LOADER_RESPONSE = `${ACTION_PREFIX}/SET_GAME_LOADER_RESPONSE`;
export const SET_GAME_LOADER_REQUEST_PENDING = `${ACTION_PREFIX}/SET_GAME_LOADER_REQUEST_PENDING`;
export const SET_CLEANUP_LISTENERS = `${ACTION_PREFIX}/SET_CLEANUP_LISTENERS`;
export const SET_LOAD_AS = `${ACTION_PREFIX}/SET_LOAD_AS`;
export const SET_GAME_MODE = `${ACTION_PREFIX}/SET_GAME_MODE`;
export const SET_MOBILE_TOOLBAR_BUTTONS = `${ACTION_PREFIX}/SET_MOBILE_TOOLBAR_BUTTONS`;
export const RESET_GAME_SLOT = `${ACTION_PREFIX}/RESET_GAME_SLOT`;
export const SET_GAME_SLOT_POSITION = `${ACTION_PREFIX}/SET_GAME_SLOT_POSITION`;
export const SET_ALL_GAME_POSITIONS = `${ACTION_PREFIX}/SET_ALL_GAME_POSITIONS`;
export const UPDATE_GAME_SLOTS = `${ACTION_PREFIX}/UPDATE_GAME_SLOTS`;
export const UPDATE_GAME_SLOT = `${ACTION_PREFIX}/UPDATE_GAME_SLOT`;
